import { render } from "./ObjectivesReportView.vue?vue&type=template&id=7458715a&scoped=true&ts=true"
import script from "./ObjectivesReportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectivesReportView.vue?vue&type=script&setup=true&lang=ts"

import "./ObjectivesReportView.vue?vue&type=style&index=0&id=7458715a&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7458715a"],['__file',"resources/js/views/objectives-report/ObjectivesReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7458715a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7458715a', __exports__)) {
    console.log('reload')
    api.reload('7458715a', __exports__)
  }
  
  module.hot.accept("./ObjectivesReportView.vue?vue&type=template&id=7458715a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('7458715a', render)
  })

}


export default __exports__